import { render } from "./ErrorDisplay.vue?vue&type=template&id=76f6a5a8&ts=true"
import script from "./ErrorDisplay.vue?vue&type=script&lang=ts"
export * from "./ErrorDisplay.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__